<template>
  <van-tabs
    v-model="active"
    sticky>
    <van-tab title="等待支付">
      <OrderList status="等待支付"/>
    </van-tab>
    <van-tab title="已完成">
      <OrderList status="已完成"/>
    </van-tab>
    <van-tab title="已取消">
      <OrderList status="已取消"/>
    </van-tab>
  </van-tabs>
</template>

<script>
import OrderList from './components/OrderList.vue';

export default {
  name: 'Order',
  components: {
    OrderList,
  },
  data() {
    return {
      active: 0,
    };
  },
  activated() {
    this.active = 0;
  },
  mounted() {
    this.active = 0;
  },
};
</script>
